import affiliateShort from '../../assets/affiliate_short.png'; 
import affiliateLong from '../../assets/affiliate_long.png'; 
import buttonImage from '../../assets/button_image5.png'; 
import { useNavigate } from "react-router-dom";
import './AffiliateSection.css';

const Affiliate = () => {
  const navigate = useNavigate();

  const goToAffiliateGuide = () => {
    navigate("/affiliateGuide");
  };

  return (
    <div>
      <div className="affiliate-section">
        <div style={{ height: '100px' }} />

        <h1 className="affiliate-title"
          data-aos="fade-down"
          data-aos-duration="600"
        >Earn by Simply Sharing</h1>

        <p
          data-aos="fade-right"
          data-aos-duration="500"
          data-aos-delay="120"
        >
          Earn more than <span>$10K/month</span> just by posting videos on social media. Get <span>70%</span> of each sale, meaning you get paid for doing things you enjoy! Get your referral link, Invite your friends now and get rewarded instantly.
        </p>

        <div className="affiliate-image-row">
          <div className="left-image"
            data-aos="fade-right"
            data-aos-duration="500"
            data-aos-delay="300"
          >
            <img src={affiliateShort} alt="Left Illustration" className="affiliate-image-short" />
          </div>
          <div className="right-image"
            data-aos="fade-up"
            data-aos-duration="500"
            data-aos-delay="300"
          >
            <img src={affiliateLong} alt="Right Illustration" className="affiliate-image-long" />
          </div>
        </div>

        <h2
          data-aos="fade-down"
          data-aos-duration="500"
          data-aos-offset="100"
        >Earn $10k/month</h2>

        {/* Wrapper gives the absolute button a proper parent and reserves space */}
        <div className="affiliate-button-wrapper"
          data-aos="zoom-in"
          data-aos-duration="500"
          data-aos-delay="200"
        >
          <button className="affiliate-image-button" onClick={goToAffiliateGuide}>
            <img src={buttonImage} alt="Affiliate Button" draggable="false" />
          </button>
        </div>

      </div>
    </div>
  );
};

export default Affiliate;